import React from 'react';
import classnames from 'classnames';
import { GroupHero } from './GroupHero';
import { GroupPeople } from './GroupPeople';

import Icon from 'assets/icons';

import { useSidebarState, useSidebarDispatch } from 'context';

import styles from './GroupSideDrawer.module.scss';

interface GroupSideDrawerProps {
  showPinned?: boolean;
  togglePinned?: () => void;
}

export const GroupSideDrawer: React.FC<GroupSideDrawerProps> = ({ showPinned, togglePinned }) => {
  const sidebarState = useSidebarState();
  const sidebarDispatch = useSidebarDispatch();

  const openDrawer = sidebarState.open;

  const closeSidebar = React.useCallback(() => {
    sidebarDispatch({ type: 'CLOSE_SIDEBAR' });
  }, [sidebarDispatch]);

  const togglePinnedAndClose = () => {
    closeSidebar();
    togglePinned && togglePinned();
  };

  return (
    <>
      <div
        className={classnames(styles.overlay, openDrawer && styles.open)}
        onClick={closeSidebar}
      />
      {openDrawer && (
        <aside className={classnames(styles.container, openDrawer && styles.openDrawer)}>
          <div className={styles.innerWrap}>
            <span className={styles.groupsClose} onClick={closeSidebar}>
              <Icon.MenuClose />
            </span>
            <GroupHero togglePinned={togglePinnedAndClose} showPinned={showPinned} />
            <GroupPeople />
          </div>
        </aside>
      )}
    </>
  );
};
